import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';
import { fromJson } from '@client/core/data/concerns/parses-from-json/from-json';

/**
 * File that a User has uploaded to our software.
 *
 * @see app/Http/Resources/AttachmentResource.php
 * TODO: Move to client/features/attachments/models/attachment.ts
 */
export class Attachment {
  constructor(
    public readonly id: number,
    public readonly uuid: string,
    public readonly name: string,
    public readonly filename: string,
    public readonly filenameOriginal: Nullable<string>,
    public readonly source: string,
    public readonly sourceUrl: string,
    public readonly sourceDownloadUrl: string,
    public readonly type: string,
    public readonly size: Nullable<number>,
    public readonly previewUrl: string,
    public readonly allPreviewUrls: Nullable<AttachmentPreviewUrls>,
  ) {}
}

defineTransform(Attachment, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
    allPreviewUrls: json.all_preview_urls ? fromJson(AttachmentPreviewUrls, json.all_preview_urls) : null,
  };
});

/**
 * URLs for various sized preview images of an Attachment.
 */
export class AttachmentPreviewUrls {
  constructor(public readonly thumbnail: string, public readonly medium: string, public readonly large: string) {}
}
defineTransform(AttachmentPreviewUrls, (json, { fromSnakeCaseKeys }) => {
  return {
    ...fromSnakeCaseKeys(),
  };
});
